<template>
  <div class="music-temp-manage">
    <el-card>
      <div slot="header" class="card-header">
        <span>音乐模板管理</span>
        <el-button type="primary" size="small" @click="openAddDialog">新增模板</el-button>
      </div>

      <!-- 列表 -->
      <el-table :data="tableData" border stripe v-loading="loading" style="width:100%">
        <el-table-column prop="name" align="center" label="模板名称" width="400"/>
        <el-table-column prop="type" align="center" label="类型" width="100">
          <template slot-scope="{ row }">
            <el-tag :type="row.type == '0' ? 'success' : 'primary'" size="small">
              {{ row.type == '0' ? '公共' : '私有' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="content" label="内容" show-overflow-tooltip />
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="danger" size="mini" @click="handleDel(row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top:16px;text-align:right"
        background
        layout="total, sizes, prev, pager, next"
        :total="total"
        :page-size="query.pageSize"
        :current-page="query.page"
        :page-sizes="[10, 20, 50]"
        @size-change="val => { query.pageSize = val; fetchList() }"
        @current-change="val => { query.page = val; fetchList() }"
      />
    </el-card>

    <!-- 新增弹窗 -->
    <el-dialog title="新增音频模板" :visible.sync="dialogVisible" width="500px" @close="resetForm">
      <el-form :model="form" :rules="rules" ref="addForm" label-width="90px" size="small">
        <el-form-item label="模板名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入模板名称" />
        </el-form-item>
        <el-form-item label="类型" prop="type" v-if="username === 'admin'">
          <el-radio-group v-model="form.type">
            <el-radio label="0">公共</el-radio>
            <el-radio label="1">私有</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="音色">
          <el-select  v-model="form.voice" @change="handleChange" filterable placeholder="请选择音色" style="margin-right:10px">
            <el-option :label="item.name + '（' + item.type + '）'" :value="item.voice" :key="item.id" v-for="item in voiceArr"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="语速">
          <el-input-number v-model="form.speechRate" @change="handleChange" :precision="1" :step="0.1" :min="0.5" :max="2"></el-input-number>
        </el-form-item>
        <el-form-item label="语调">
          <el-input-number v-model="form.pitchRate" @change="handleChange" :precision="0" :step="1" :min="-500" :max="500"></el-input-number>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input v-model="form.content" type="textarea" :rows="3" placeholder="请输入内容" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button type="warning" size="small" :loading="ylSubmitting" @click="handleYl">预览</el-button>
        <el-button type="primary" size="small" :loading="submitting" @click="handleAdd">确定</el-button>
      </div>
    </el-dialog>

    <!-- 同步门店弹窗 -->
    <el-dialog title="同步门店" :visible.sync="dialogSyncVisible" width="70%">
      <el-button type="primary" size="mini" @click="handleAddStore">新增</el-button>
      <el-table :data="stTableData" border stripe style="width:100%">
        <el-table-column prop="storename" align="center" label="门店名称" width="400"/>
        <el-table-column label="时间" align="center">
          <template slot-scope="scope">
                  <span v-if="scope.row.startTime">
                    {{parseDate(scope.row.startTime) + '~' + parseDate(scope.row.endTime)}}
                  </span>
            <span v-else>全天</span>
          </template>
        </el-table-column>
        <el-table-column label="频率" align="center">
          <template slot-scope="scope">
            {{scope.row.jh}}小时/次
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="handleEditMusicPlan(scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="handleDelMusicPlan(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 选择店铺 -->
    <el-dialog :title="planTitle" :visible.sync="selectStoreDialogVisible" width="50%" @close="selectStoreDialogVisible=false">
      <el-form ref="musicPlan" :model="musicPlanForm" :rules="musicPlanRules" label-width="120px">
        <el-form-item label="门店" prop="storeid" v-if="!this.musicPlanForm.id">
          <el-select  v-model="musicPlanForm.storeid" clearable filterable placeholder="请选择门店" style="margin-right:10px">
            <el-option :label="item.storename" :value="item.id" :key="item.id" v-for="item in stores"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="播放频率" prop="jh">
          <el-select  v-model="musicPlanForm.jh" clearable filterable placeholder="请选择播放频率" style="margin-right:10px">
            <el-option :label="item.name" :value="item.id" :key="item.id" v-for="item in plArr"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="启用时间">
          <el-time-picker
              is-range
              clearable
              v-model="planTimes"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              format="HH:mm"
              placeholder="不设置则是全天生效">
          </el-time-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
              <el-button @click="selectStoreDialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="submitMusicPlan">确 定</el-button>
            </span>
    </el-dialog>

    <el-dialog title="预览音频" :visible.sync="musicDialogVisible" width="300px">
      <el-card class="box-card">
        <!-- 添加 controls 属性即可显示原生播放器界面 -->
        <audio controls style="width: 100%;">
          <source :src="musicPath" type="audio/mpeg">
          您的浏览器不支持 audio 标签。
        </audio>
      </el-card>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'MusicTempManage',
  data() {
    return {
      username: null,
      loading: false,
      ylSubmitting: false,
      submitting: false,
      dialogVisible: false,
      musicDialogVisible: false,
      dialogSyncVisible: false,
      selectStoreDialogVisible: false,
      tableData: [],
      stTableData: [],
      stores: [],
      voiceArr: [],
      total: 0,
      query: {
        page: 1,
        pageSize: 10
      },
      musicPath: null,
      form: {
        name: '',
        type: '1',
        content: '',
        voice: 'xiaoyun',
        speechRate: 1.0,
        pitchRate: 0,
        username: this.username,
        path: null
      },
      rules: {
        name: [{ required: true, message: '请输入模板名称', trigger: 'blur' }],
        content: [{ required: true, message: '请输入内容', trigger: 'blur' }]
      },
      planTitle: null,
      musicPlanForm: {},
      musicPlanRules: {
        jh: [
          { required: true, message: '请选择执行频率', trigger: 'blur' },
        ],
        storeid: [
          { required: true, message: '请选择门店', trigger: 'blur' },
        ]
      },
      planTimes: null,
      tempId: null,
      plArr: [
        {
          id: 1,
          name: '1小时/次'
        },
        {
          id: 2,
          name: '2小时/次'
        },
        {
          id: 3,
          name: '3小时/次'
        },
        {
          id: 4,
          name: '4小时/次'
        },
        {
          id: 5,
          name: '5小时/次'
        },
        {
          id: 6,
          name: '6小时/次'
        },
        {
          id: 12,
          name: '12小时/次'
        },
        {
          id: 24,
          name: '24小时/次'
        }
      ],
    }
  },
  created() {
    this.username = window.sessionStorage.getItem('username')
    this.getVoice()
    this.fetchList()
  },
  methods: {
    parseDate(date) {
      let dat = new Date(date)
      return (dat.getHours() > 10 ? dat.getHours() : '0' + dat.getHours()) + ':' + (dat.getMinutes() > 10 ? dat.getMinutes() : '0' + dat.getMinutes())
    },
    getVoice() {
      this.voiceArr = []
      this.$http.get('/musicTemp/getVoice')
          .then(res => {
            console.log(res)
            if (res.data.status == 0) {
              this.voiceArr = res.data.data
            }
          })
    },
    fetchList() {
      this.loading = true
      const { page, pageSize } = this.query
      this.$http.get('/musicTemp/list', { params: { page, pageSize } })
        .then(res => {
          if (res.data.status === 0) {
            this.tableData = res.data.data.list
            this.total = res.data.data.total
          } else {
            this.$message.error(res.data.message || '查询失败')
          }
        })
        .catch(() => this.$message.error('请求失败'))
        .finally(() => { this.loading = false })
    },
    openAddDialog() {
      this.dialogVisible = true
    },
    handleYl() {
      this.$refs.addForm.validate(valid => {
        if (!valid) return

        if (this.musicPath) {
          this.musicDialogVisible = true
          return;
        }

        this.ylSubmitting = true
        let obj = {...this.form}
        if (obj.speechRate == 1.0) {
          obj.speechRate = 0
        } else {
          if (obj.speechRate > 1.0) {
            obj.speechRate = (1-1/obj.speechRate)/0.001
          } else {
            obj.speechRate = (1-1/obj.speechRate)/0.002
          }
        }

        this.$http.post('/musicTemp/ylMusic', obj)
          .then(res => {
            console.log('预览返回值---', res)
            if (res.data.status == 0) {
              this.form.path = res.data.path
              this.musicPath = this.$http.defaults.baseURL + res.data.prefix + res.data.path
              this.musicDialogVisible = true
            } else {
              this.$message.error(res.data.message || '预览失败')
            }
          })
          .catch(() => this.$message.error('请求失败'))
          .finally(() => { this.ylSubmitting = false })
      })
    },
    handleAdd() {
      this.$refs.addForm.validate(valid => {
        if (!valid) return
        this.submitting = true

        let obj = {...this.form}
        if (obj.speechRate == 1.0) {
          obj.speechRate = 0
        } else {
          if (obj.speechRate > 1.0) {
            obj.speechRate = (1-1/obj.speechRate)/0.001
          } else {
            obj.speechRate = (1-1/obj.speechRate)/0.002
          }
        }

        this.$http.post('/musicTemp/add', obj)
          .then(res => {
            if (res.data.status === 0) {
              this.$message.success('新增成功')
              this.dialogVisible = false
              this.fetchList()
            } else {
              this.$message.error(res.data.message || '新增失败')
            }
          })
          .catch(() => this.$message.error('请求失败'))
          .finally(() => { this.submitting = false })
      })
    },
    handleDel(id) {
      this.$confirm('确认删除该模板？', '提示', { type: 'warning' })
        .then(() => {
          this.$http.post(`/musicTemp/del/${id}`)
            .then(res => {
              if (res.data.status === 0) {
                this.$message.success('删除成功')
                this.fetchList()
              } else {
                this.$message.error(res.data.message || '删除失败')
              }
            })
            .catch(() => this.$message.error('请求失败'))
        })
        .catch(() => {})
    },
    resetForm() {
      this.musicPath = null
      this.$refs.addForm && this.$refs.addForm.resetFields()
      this.form = { name: '', type: '1', content: '', voice: 'xiaoyun', speechRate: 1.0, pitchRate: 0, username: this.username, path: null }
    },
    handleChange() {
      this.form.path = null
      this.musicPath = null
    },
    async handleSync(id) {
      this.tempId = id
      this.stTableData = []
      const { data: res } = await this.$http.post('getMusicTempPlan', {tempId: id})
      if(res.status == 0 && res.data.length){
        this.stTableData = res.data
        this.dialogSyncVisible = true
      } else {
        this.$message.error('请求失败')
      }
    },
    handleAddStore() {
      this.restPlan()
      this.planTitle = '添加语音计划'
      this.selectStoreDialogVisible = true
    },
    // 打开编辑语音计划弹窗
    handleEditMusicPlan(row){
      this.restPlan()
      this.musicPlanRules.storeid = []
      this.musicPlanForm = row
      if (row.startTime) {
        this.planTimes = [new Date(row.startTime), new Date(row.endTime)]
      }
      this.planTitle = '修改语音计划'
      this.selectStoreDialogVisible = true
    },
    // 提交音乐计划
    submitMusicPlan(){
      this.$refs["musicPlan"].validate(valid => {
        if (valid) {
          this.musicPlanForm.topic = this.stores.filter(item => item.id == this.musicPlanForm.storeid)[0].musicTopic
          if (this.planTimes && this.planTimes.length > 0) {
            this.musicPlanForm.startTime = this.planTimes[0]
            this.musicPlanForm.endTime = this.planTimes[1]
          }

          this.$http.post('operaMusicTempPlan',this.musicPlanForm).then(res => {
            let dat = res.data
            if(dat.status===0)
            {
              this.$message({message: '操作成功',type: 'success'})
            }

            this.getPlanList()
            this.selectStoreDialogVisible = false
          })
        }
      });
    },
    // 重置音乐计划表单
    async restPlan(){
      this.planTimes = null
      this.musicPlanRules.storeid = [
        { required: true, message: '请选择门店', trigger: 'blur' },
      ]
      this.musicPlanForm = {
        id: null,
        jh: null,
        tempId: this.tempId,
        storeid: null,
        startTime: null,
        endTime: null
      }
      this.stores = []
      const { data: res } = await this.$http.get(`/musicTemp/getStoreList`)
      if (res.status === 0) {
        let stores = res.data
        let st = this.stTableData.map(item => item.storeid)
        this.stores = stores.filter(item => st.indexOf(item.id) == -1)
      } else {
        this.$message.error(res.data.message || '查询失败')
      }
    },
    // 删除语音计划
    async handleDelMusicPlan(index, row) {
      const confirmResult = await this.$confirm('确定要删除此门店吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err);

      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消！');
      }
      const { data:res } = await this.$http.post('delMusicTempPlan',{topic: row.musicTopic, id: row.id})
      if(res.status===0)
      {
        this.stTableData.splice(index, 1)
        this.$message({message: '删除成功',type: 'success'})
      }
    },
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
